import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enCommon from './locales/en/common.json';
import enFeedback from './locales/en/feedback.json';
import enGlossary from './locales/en/glossary.json';
import enTravelQuestions from './locales/en/travelQuestions.json';
import enDestinations from './locales/en/destinations.json';
import enItinerary from './locales/en/itinerary.json';
import enWeather from './locales/en/weather.json';
import enFlights from './locales/en/flights.json';
import enAccommodations from './locales/en/accommodations.json';
import enTransport from './locales/en/transport.json';
import enCultural from './locales/en/cultural.json';

import esCommon from './locales/es/common.json';
import frCommon from './locales/fr/common.json';
import deCommon from './locales/de/common.json';
import itCommon from './locales/it/common.json';

const resources = {
  en: {
    common: enCommon,
    feedback: enFeedback,
    glossary: enGlossary,
    travelQuestions: enTravelQuestions,
    destinations: enDestinations,
    itinerary: enItinerary,
    weather: enWeather,
    flights: enFlights,
    accommodations: enAccommodations,
    transport: enTransport,
    cultural: enCultural,
  },
  es: {
    common: esCommon,
  },
  fr: {
    common: frCommon,
  },
  de: {
    common: deCommon,
  },
  it: {
    common: itCommon,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
